import { autoUpdate, useFloating } from '@floating-ui/react-dom';
import { useOutsideClick } from 'modules/hooks/useOutsideClick';
import { getFloatingPositionMiddleware } from './middleware';
import { useEscapeCallback } from './useEscapeCallback';
/**
 * Hook to position an element (float) to another element (target).
 *
```
  // Example usage
  const { refs, wrapperStyle } = useFloatingPosition({
    active: true,
    outsideClickTrigger: () => console.log('Clicked "outside".')
  })
 
  <button ref={refs.setReference}>Target</button>
  <div ref={refs.setFloat} style={wrapperStyle}>I will be positioned to the button</div>
```
 */
export function useFloatingPosition(contextPosition) {
    var _a, _b;
    const { options, offset, active = true, outsideClickTrigger } = contextPosition;
    const mergedOptions = Object.assign({ middleware: [...getFloatingPositionMiddleware({ offset })], placement: 'bottom-start', strategy: 'fixed' }, options);
    const fui = useFloating(Object.assign(Object.assign({}, mergedOptions), { whileElementsMounted: autoUpdate }));
    useEscapeCallback({
        elements: [fui.refs.reference, fui.refs.floating],
        callback: () => {
            if (outsideClickTrigger) {
                outsideClickTrigger();
            }
        },
        active,
    });
    useOutsideClick({
        elements: [fui.refs.reference, fui.refs.floating],
        callback: () => {
            if (outsideClickTrigger) {
                outsideClickTrigger();
            }
        },
        active,
    });
    const wrapperStyle = {
        position: fui.strategy,
        top: (_a = fui.y) !== null && _a !== void 0 ? _a : 0,
        left: (_b = fui.x) !== null && _b !== void 0 ? _b : 0,
    };
    return {
        refs: fui.refs,
        wrapperStyle,
    };
}
